import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  ImportOrdersStoreService,
  IMPORT_ORDERS_ACTIONS,
} from '@usf/ngrx-order';
import { switchMap, withLatestFrom } from 'rxjs';
import { createSubmitFileAnalytics } from '../factories/import-order-validation-factories';
import { IMPORT_ORDER_VALIDATION_ANALYTICS_ACTIONS } from './import-order-validation-analytics.actions';

@Injectable({
  providedIn: 'root',
})
export class ImportOrderValidationAnalyticsEffects {
  submitImport$ = createEffect(() =>
    this.actions$.pipe(ofType(IMPORT_ORDERS_ACTIONS.submit)).pipe(
      withLatestFrom(this.importOrderStoreService.fileFormat$()),
      switchMap(([submitPayload, fileFormat]) => [
        IMPORT_ORDER_VALIDATION_ANALYTICS_ACTIONS.submitImport({
          tracking: createSubmitFileAnalytics(fileFormat),
        }),
      ]),
    ),
  );
  constructor(
    private actions$: Actions,
    private importOrderStoreService: ImportOrdersStoreService,
  ) {}
}
